import React, {Component} from "react";
import SimpleModal from "../../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../../modules/SimpleInput";
import InventoryUnitTable from "../../common/InventoryUnitTable";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import { defaultTableChange } from "../../../../../../modules/custom/customTable";

class InventoryUnitStockInfo extends Component {
    tableConfig = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {rowsPerPage} = tableMeta.tableState;
                    const rowNumber = 0 * rowsPerPage + tableMeta.rowIndex + 1
                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "noSin",
            label: "No Sin",
            options: {
                sort: false,
            },
        },
        {
            name: "note",
            label: "Jenis Transaksi",
            options: {
                sort: false,
            },
        },
        {
            name: "trxId",
            label: "Doc No.",
            options: {
                sort: false,
            },
        },
    ]

    dummyDataUnitInfo = [
        {
            "noSin" : "HCK-1234",
            "jenisTransaksi" : "Mutasi Masuk",
            "docNo" : "HCK-1234",
        }
    ]

    constructor(props) {
        super(props);
        this.state = {
            dataTable: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    componentDidMount() {
        this.fetchDataUnitInfo();
    }

    fetchDataUnitInfo = async() => {
        try {
            const res = await fetchDataAsync({
              asyncFn: Api.create("NAGAMAS_TRANSACTION")
                .getCardStockInventoryDetail,
              menuName: "Detail Card Stock Inventory",
              setError: this.props.setError,
              args: {
                date: this.props.selectedData?.date,
                kodeCabang: this.props.dataUnit?.kodeCabang,
                locator: this.props.dataUnit?.kodeLokasi,
                variant: this.props.dataUnit?.kodeVariant,
                colorCode: this.props.dataUnit?.idWarna,
                transactionType: this.props.selectedData?.trxType,
              },
            });
            if(res.ok && res.data.status === HttpStatus.SUCCESS){
                 this.setState((prevState) => ({
                   ...prevState,
                   dataTable: res.data.data,
                   pagination: {
                     ...prevState.pagination,
                     totalData: res.data.data.length,
                   },
                 }));
            }
        } catch (error) {
            console.log(error)
        }
       
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        return (
            <SimpleModal
                title="Detail Stock Info"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                        <div className="grid grid-3x grid-mobile-none gap-20px margin-bottom-20px">
                            <div id="grid-1">
                                <SimpleInput
                                    id="input_text_kode_variant"
                                    name="tglTransaksi"
                                    label="Tanggal"
                                    readOnly={true}
                                    value={this.props.selectedData.date}
                                />
                            </div>
                        </div>
                        <SimpleDataTable
                          key={`${this.state.pagination.totalData}-${this.state.pagination.page}`}
                          data={this.state.dataTable}
                          columns={this.tableConfig}
                          toCount={this.state.pagination.totalData}
                          rowsPerPage={this.state.pagination.limit}
                          page={this.state.pagination.page - 1}
                          options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                        />
                        <div style={{textAlign: "right", marginTop: "10px"}}>
                            <SimpleButton
                                onClick={() => this.props.onClickClose()}
                                secondary
                                text={"Kembali"}
                            />
                        </div>
                    </ModalContainer>
                }
            />
        )
    }
}

export default InventoryUnitStockInfo;